import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Accordion } from "@mantine/core";
import { useAppAction, useAppSelector } from "../../hooks/redux.js";
import { getAllVersions, getPrimaryVersionId } from "../../utils/state.js";
import { restoreVersion, setPrimaryVersion, setSecondaryVersion } from "../../reducers/historyEnhancer.js";
import { VersionListItemControl } from "./VersionListItemControl.js";
import { VersionListItemPanel } from "./VersionListItemPanel.js";
export const VersionList = () => {
    const changePrimary = useAppAction(setPrimaryVersion);
    const changeSecondary = useAppAction(setSecondaryVersion);
    const restore = useAppAction(restoreVersion);
    const primary = useAppSelector(getPrimaryVersionId);
    const allVersions = useAppSelector(getAllVersions);
    const handleSelect = (index) => {
        if (index === null) {
            changePrimary(null);
            changeSecondary(null);
            return;
        }
        const indexNumber = Number(index);
        changePrimary(indexNumber);
        if (indexNumber < allVersions.length) {
            changeSecondary(indexNumber + 1);
        }
        else {
            changeSecondary(indexNumber);
        }
    };
    return (_jsx(Accordion, { variant: "default", onChange: handleSelect, value: primary?.toString() ?? null, children: allVersions.map((currentVersion, index) => {
            const bg = primary === index
                ? "light-dark(var(--mantine-color-gray-1), var(--mantine-color-dark-2))"
                : "light-dark(var(--mantine-color-white), var(--mantine-color-dark-5))";
            const { init: { action, version, published, current, text, messageId, }, } = currentVersion;
            return (_jsxs(Accordion.Item, { value: index.toString(), bg: bg, children: [_jsx(VersionListItemControl, { action: action, version: version, published: published, current: current, text: text, messageId: messageId, selected: primary === index, canRestore: index > 0, onRestore: () => restore(index) }), _jsx(VersionListItemPanel, {})] }, index));
        }) }));
};
